import { Component, OnInit } from '@angular/core';
import { ApsAssignedList } from 'src/app/models/aps-assigned-list';
import { ApsAssignedFacade } from 'src/app/ngrx/aps_assinged/aps_assinged.facade';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { FormDataFacade } from 'src/app/ngrx/form-data/form-data.facade';
import * as moment from 'moment';

@Component({
  selector: 'app-checking-out-modal',
  templateUrl: './checking-out-modal.component.html',
  styleUrls: ['./checking-out-modal.component.scss']
})
export class CheckingOutModalComponent implements OnInit {
  checkOutList: Array<ApsAssignedList>;
  assignedAgentId: number;
  currentNumber = 0;
  constructor(
    public bsModalRef: BsModalRef,
    private router: Router,
    private apsAssignedFacade: ApsAssignedFacade,
    private api: ApiService,
    private fdFacade: FormDataFacade
  ) { }

  ngOnInit() {
    this.checkOutList.map(
      data => {
        data.date_created = moment().format('MM/DD/YYYY HH:mm');
        this.apsAssignedFacade.insertApsAssignedCheckOutItem(data);
        this.api.getValues(+data.aps_report_load_id).subscribe(
          apsData => {
            this.fdFacade.insertDataToDB(+data.aps_report_load_id, this.assignedAgentId, apsData);
            this.currentNumber = this.currentNumber + 1;
            if (this.currentNumber === this.checkOutList.length) {
              this.router.navigate(['/checkout-list']);
              setTimeout(() => { this.bsModalRef.hide(); }, 100);
            }
          }
        );
      }
    );
  }

}
